exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".settingsPosition-d3108cc1{position:relative;top:0px;left:9px}\n", ""]);

// Exports
exports.locals = {
	"settingsPosition": "settingsPosition-d3108cc1"
};